import { gql } from '@apollo/client';

export const CREATE_USER_BULK_MUTATION = gql`
  mutation CreateUserBulk($userBulkCreateDto: UserBulkCreateDto!) {
    createUserBulk(userBulkCreateDto: $userBulkCreateDto) {
      succeeded
      errors {
        email
        message
      }
    }
  }
`;
